const vi = {
  meta: { code: "vi", label: "Tiếng Việt" },
  nav: {
    brand: "IQ Log",
    diagnostics: "Bài đánh giá",
    mypage: "Trang của tôi",
    login: "Đăng nhập",
    register: "Đăng ký",
    logout: "Đăng xuất",
  },
  hero: {
    eyebrow: "Nền tảng đánh giá",
    title: "Khám phá bản chất qua các bài đánh giá",
    subtitle1: "Tư duy, tính cách và năng lực — trực quan hoàn toàn",
    subtitle2: "Thấy điểm mạnh & điểm yếu của bạn trong 5 phút",
    subtitle3: "Mỗi bài đánh giá đều trở thành dữ liệu của bạn",
    cta_primary: "Bắt đầu đánh giá",
    cta_secondary: "Xem danh mục",
    disclaimer: "Thông tin tham khảo / Phi y tế",
  },
  categories: {
    ability: "Năng lực",
    personality: "Tính cách",
    mental: "Tinh thần",
    aptitude: "Sở trường",
    traits: "Đặc điểm",
  },
  catalog: {
    title: "Tất cả bài đánh giá",
    subtitle: "17 bài / 5 danh mục",
    filter_all: "Tất cả",
    duration: "phút",
    difficulty: { easy: "Dễ", medium: "Vừa", hard: "Khó" },
    question_count: "câu",
    start: "Bắt đầu",
  },
  quiz: {
    question: "Câu hỏi",
    of: "/",
    next: "Tiếp",
    prev: "Quay lại",
    submit: "Xem kết quả",
    progress: "Tiến độ",
    exit: "Thoát",
    required: "Vui lòng chọn một đáp án",
    submitting: "Đang chấm điểm…",
  },
  result: {
    overall: "Điểm tổng",
    type_label: "Loại",
    share_link: "Chia sẻ kết quả qua liên kết",
    back_to_catalog: "Làm bài khác",
    view_mypage: "Xem lịch sử trên Trang của tôi",
    premium_title: "Mở khoá phân tích chi tiết",
    premium_subtitle: "Với gói cao cấp, bạn sẽ thấy tất cả nội dung dưới đây:",
    feature_breakdown: "Phân tích điểm chi tiết",
    feature_cause: "Phân tích nguyên nhân",
    feature_plan: "Kế hoạch cải thiện",
    feature_pdf: "Báo cáo PDF (A4)",
    price: "¥980",
    price_note: "(Thanh toán an toàn qua Stripe)",
    price_free: "Miễn phí",
    price_free_note: "(Có giới hạn · 100% miễn phí)",
    unlock_button: "Thanh toán bằng Stripe",
    unlock_button_free: "Mở khoá miễn phí",
    unlock_requires_auth: "Vui lòng đăng nhập để mở khoá",
    unlock_save_first: "Hãy lưu kết quả vào tài khoản trước",
    unlocking: "Đang chuyển đến Stripe…",
    free_only_notice: "Bản miễn phí chỉ hiển thị điểm tổng và loại.",
    compliance_note:
      "Bài đánh giá này chỉ mang tính tham khảo, không phải chẩn đoán y khoa. Chúng tôi không dùng ngôn ngữ khẳng định hoặc gây sợ hãi.",
  },
  premium: {
    title: "Báo cáo phân tích chi tiết",
    summary: "Tóm tắt tổng quan",
    strengths: "Điểm mạnh",
    weaknesses: "Vùng cần phát triển",
    improvements: "Kế hoạch cải thiện",
    dimensions: "Điểm theo chiều",
    download_pdf: "Tải xuống PDF",
    pdf_soon: "Xuất PDF (sắp ra mắt)",
  },
  mypage: {
    title: "Trang của tôi",
    subtitle: "Lịch sử, xu hướng điểm và huy hiệu của bạn",
    total: "Tổng số bài",
    average: "Điểm trung bình",
    premium_count: "Đã mở khoá",
    categories_covered: "Danh mục đã làm",
    trend_title: "Xu hướng điểm",
    history_title: "Lịch sử",
    badges_title: "Huy hiệu",
    unlock_3_title: "Mở khoá phân tích tổng hợp",
    unlock_3_desc: "Làm thêm {n} bài để mở khoá phân tích tổng hợp",
    unlocked: "Đã mở khoá phân tích tổng hợp",
    no_history: "Chưa có bài đánh giá — hãy làm bài đầu tiên ngay.",
  },
  auth: {
    login_title: "Đăng nhập",
    register_title: "Tạo tài khoản",
    email: "Email",
    password: "Mật khẩu (tối thiểu 6 ký tự)",
    name: "Tên hiển thị (không bắt buộc)",
    login_btn: "Đăng nhập",
    register_btn: "Đăng ký",
    go_register: "Chưa có tài khoản? Đăng ký",
    go_login: "Đã có tài khoản? Đăng nhập",
    anon_note: "Bài đánh giá miễn phí và ẩn danh. Chỉ cần tài khoản để lưu kết quả và mở khoá cao cấp.",
    success_register: "Đã tạo tài khoản",
    success_login: "Đã đăng nhập",
    consent_section: "Đồng ý",
    consent_required: "Vui lòng chấp nhận các mục bắt buộc",
    accept_terms_pre: "Tôi đồng ý với",
    terms_link: "Điều khoản dịch vụ",
    accept_terms_post: "",
    accept_privacy_pre: "Tôi đã đọc",
    privacy_link: "Chính sách bảo mật",
    accept_privacy_post: "và đồng ý xử lý dữ liệu cá nhân của tôi",
    accept_age: "Tôi từ 16 tuổi trở lên (hoặc có sự đồng ý của người giám hộ)",
    accept_marketing: "Gửi cho tôi email về các bài đánh giá mới và khuyến mãi",
    optional: "không bắt buộc",
  },
  landing: {
    status_online: "SYSTEM ONLINE",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 TESTS",
    status_langs: "14 LANGS",
    status_ai: "AI · ON",
    title_line1: "Khám phá bản chất",
    title_line2: "trong 5 phút.",
    trust_diagnostics: "BÀI ĐÁNH GIÁ",
    trust_languages: "NGÔN NGỮ",
    trust_per_test: "MỖI BÀI",
    hud_readout: "KẾT QUẢ CHÍNH",
    hud_score_unit: "/100 TỔNG",
    hud_band: "HẠNG · GOLD",
    hud_dimensions: "CHIỀU",
    hud_dimensions_status: "3 / 3 HOẠT ĐỘNG",
    hud_syslog: "NHẬT KÝ",
    cat_eyebrow: "// DANH MỤC",
    cat_title_pre: "5 danh mục · ",
    cat_title_highlight: "17 bài đánh giá",
    view_all: "Xem tất cả",
    proto_eyebrow: "// QUY TRÌNH",
    proto_title_pre: "Mở khoá bản chất của bạn ",
    proto_title_highlight: "trong 3 bước.",
    step1_title: "Chọn một bài",
    step1_body: "Chọn từ 17 bài đánh giá. Bắt đầu ẩn danh.",
    step2_title: "Trả lời trong 5 phút",
    step2_body: "Thanh tiến độ + huy hiệu giúp bạn tiến lên.",
    step3_title: "Mở khoá bởi AI",
    step3_body: "Điểm chi tiết, kế hoạch & PDF.",
    final_eyebrow: "// SẴN SÀNG?",
    final_title_pre: "Bản chất của bạn ",
    final_title_highlight: "trong 5 phút.",
    final_subtitle: "Thấy điểm mạnh & điểm yếu của bạn trong 5 phút",
    final_button: "Bắt đầu đánh giá ngay",
  },
  footer: {
    tagline: "Nền tảng đánh giá tư duy, tính cách và năng lực",
    rights: "Bảo lưu mọi quyền.",
    legal: "Pháp lý",
    privacy: "Bảo mật",
    terms: "Điều khoản",
    about_label: "Giới thiệu / Công ty",
    compliance_label: "Tuân thủ quốc tế",
    tokushoho_label: "Đạo luật Thương mại Nhật Bản",
    data_protection_label: "Bảo vệ dữ liệu (toàn cầu)",
    data_request_label: "Xoá dữ liệu / Từ chối tiếp thị",
    disclaimer_label: "Tuyên bố từ chối",
    disclaimer_full:
      "Dịch vụ này chỉ mang tính tham khảo, không phải chẩn đoán y khoa. Chúng tôi không dùng ngôn ngữ khẳng định hoặc gây sợ hãi.",
  },
  badges: {
    "first-diagnosis": "Bài đầu tiên",
    "three-diagnostics": "3 bài",
    "five-diagnostics": "5 bài",
    "ten-diagnostics": "10 bài",
    "high-performer": "Hiệu suất cao",
    "premium-user": "Người dùng cao cấp",
  },
  lang_selector: "Ngôn ngữ",
  payment: {
    processing_title: "Đang xác minh thanh toán…",
    processing_subtitle: "Quay lại từ Stripe — đang tạo phân tích chi tiết (tối đa 20 giây)",
    success: "Đã xác nhận thanh toán — đã mở khoá cao cấp",
    expired: "Phiên thanh toán đã hết hạn. Vui lòng thử lại.",
    error: "Không thể xác minh thanh toán. Vui lòng liên hệ hỗ trợ.",
  },
};
export default vi;
